module.exports = __webpack_public_path__ + "static/media/button_nagi7e117eddb2d2f10b2bed97643e350449.webp";